exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#uploadBtn > input {\n  display: none;\n}\n#uploadBtn {\n  padding: 2px 8px;\n  background: #efefef;\n  color: #000000;\n  border: 1px solid;\n  cursor: default;\n}\n", ""]);

// exports
